import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UsuariosService {

  constructor(private readonly http: HttpClient) {
  }

  listarUsuariosActivos(data:any): Observable<any[]> {
    const headers = { 'Content-Type': 'application/json' };
    const body = JSON.stringify(data);
    return this.http.post<any>(`${environment.API_DOMAINS.USUARIOS}/usuarios/listarUsuariosActivos`,body, { headers });
  }
  
  listarUsuarios(): Observable<any[]> {
    const headers = { 'Content-Type': 'application/json' };
    return this.http.get<any>(`${environment.API_DOMAINS.USUARIOS}/usuarios/listarUsuarios`, { headers });
  }

  guardarUsuario(data:any): Observable<any> {
    const body = JSON.stringify(data);
    const headers = { 'Content-Type': 'application/json' };
    return this.http.post<any>(`${environment.API_DOMAINS.USUARIOS}/usuarios/agregarUsuario`,body, { headers });
  }

  listarUsuariosPag(data:any): Observable<any[]> {
    const body = JSON.stringify(data);
    const headers = { 'Content-Type': 'application/json' };
    return this.http.post<any>(`${environment.API_DOMAINS.USUARIOS}/usuarios/listarUsuariosPag`,body, { headers });
  }

  editarUsuario(data:any): Observable<any[]> {
    const body = JSON.stringify(data);
    const headers = { 'Content-Type': 'application/json' };
    return this.http.post<any>(`${environment.API_DOMAINS.USUARIOS}/usuarios/editarUsuario`,body, { headers });
  }

  obtenerUsuario(data:any): Observable<any> {
    const headers = { 'Content-Type': 'application/json' };
    return this.http.get<any>(`${environment.API_DOMAINS.USUARIOS}/usuarios/obtenerUsuario?email=${data.email}&usuId=${data.usuId}`, { headers });
  }

  obtenerPermisosPorRol(rolId: any): Observable<any[]> {   
    return this.http.get<any>(`${environment.API_DOMAINS.USUARIOS}/usuarios/obtenerPermisosPorRol/${rolId}`);
  }
  
  listarUsuariosAnalistas(nombre: any): Observable<any[]> {
    return this.http.get<any>(`${environment.API_DOMAINS.USUARIOS}/usuarios/listarUsuariosAnalistaFzas/${nombre}`);
  }
}
